import { render, staticRenderFns } from "./StockOpnameNew_Details.vue?vue&type=template&id=4144aae3&"
import script from "./StockOpnameNew_Details.vue?vue&type=script&lang=js&"
export * from "./StockOpnameNew_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports